import React from 'react';
import { RefreshCw } from 'lucide-react';
import { reportClientError } from '../lib/errorReporter';

/**
 * ErrorBoundary — catches React rendering crashes (often caused by browser
 * extensions like Google Translate modifying the DOM) and shows a recovery UI.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('MUZI ErrorBoundary caught:', error, info);
    reportClientError({
      message: error?.message || 'React render crash',
      stack: error?.stack,
      componentStack: info?.componentStack,
      source: 'boundary',
    });
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  reload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#0A0A0F] text-white p-6">
          <div className="glass rounded-3xl p-8 max-w-md text-center" translate="no">
            <div className="text-6xl mb-4">⚡</div>
            <h2 className="text-2xl font-black mb-2">Petit hic technique</h2>
            <p className="text-zinc-400 text-sm mb-2">
              L&apos;app a rencontré un souci d&apos;affichage.
            </p>
            <p className="text-zinc-500 text-xs mb-6">
              Astuce : désactive <strong>Google Translate</strong> sur cette page
              (ou les extensions qui modifient le contenu), ça résout 90% des cas.
            </p>
            <div className="flex gap-3 justify-center">
              <button onClick={this.reset} className="btn-neon h-11 px-5 rounded-xl text-white border-0 font-bold inline-flex items-center gap-2">
                <RefreshCw size={16} /> Réessayer
              </button>
              <button onClick={this.reload} className="h-11 px-5 rounded-xl bg-white/5 hover:bg-white/10 text-white border border-white/15 font-bold">
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
